{
  "version": 1,
  "asset_id": "3ac4231c-0d66-411a-9697-3ef4686e4f2c",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/3ac4231c-0d66-411a-9697-3ef4686e4f2c/svc-web-design-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/3ac4231c-0d66-411a-9697-3ef4686e4f2c/svc-web-design-640.webp",
  "original_filename": "svc-web-design-640.webp",
  "size": 3512,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:27:01Z"
}
